<div style="display:none" [style.display]="overlayShowHide()" class="ui-widget-overlay ui-front">
  <div style=" position:fixed; top: 50%; left: 50%; width: auto; height: auto;" [style.display]="spinnerShowHide()">
    <img src="assets/images/Rolling.gif">
  </div>
</div>